import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from './Divider';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const useStyles = makeStyles(theme => ({
  icon: {
    minWidth: 40,
  },
  chevron: {
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  chevronRight: {
    transform: 'rotate(-180deg)',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

function CollapseButton(props) {
  const { isOpen, onClick } = props;
  const classes = useStyles();
  return (
    <Fragment>
      <Divider />
      <ListItem button onClick={onClick}>
        <ListItemIcon classes={{ root: classes.icon }}>
          <ChevronLeftIcon
            classes={{ root: clsx(classes.chevron, { [classes.chevronRight]: !isOpen }) }}
          />
        </ListItemIcon>
        <ListItemText primary="Contraer" />
      </ListItem>
      <Divider />
    </Fragment>
  );
}

CollapseButton.propTypes = propTypes;

export default CollapseButton;
